import React, { FC } from 'react';
import Button, { ButtonProps } from '@app/components/Button';
import NoFilteredDataImage from '@app/images/table/no-filtered-data.svg';
import SVG from '@app/components/SVG';
import { BodySmallStartTransparentBlack900, Regular28TransparentBlack900 } from '@app/components/Text';
import styled from '@emotion/styled';

interface Props {
  content: string;
  button?: ButtonProps;
  className?: string;
}

const TableEmptyFilteredData: FC<Props> = ({ content, button, className }) => {
  return (
    <Container className={className}>
      <NoDataSVG accessibilityLabel='' image={NoFilteredDataImage} width={68} height={73} />
      <MainText>No results</MainText>
      <SecondaryText>{content}</SecondaryText>
      {button && <ActionButton appearance='text' {...button} />}
    </Container>
  );
};

export default TableEmptyFilteredData;

const Container = styled.div`
  padding: 80px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NoDataSVG = styled(SVG)`
  margin-bottom: 50px;
`;

const MainText = styled(Regular28TransparentBlack900.div)`
  margin-bottom: 8px;
`;

const SecondaryText = styled(BodySmallStartTransparentBlack900.div)`
  white-space: pre-wrap;
  text-align: center;
`;

const ActionButton = styled(Button)`
  margin-top: 22px;
  display: inline-block;
`;
